import { defineComponent } from 'vue';
import props from './descriptions-item-props';

export default defineComponent({
  name: 'TDescriptionsItem',
  props,
});
